import { Button, ButtonProps } from '@palmetto/palmetto-components';
import { useFormikContext } from 'formik';

interface ITCCalculateButtonProps {
  isLoading?: boolean;
  children: React.ReactNode;
  size: ButtonProps['size'];
  variant: ButtonProps['variant'];
  onClick?: () => void;
  disabled?: boolean;
}

export const ITCCalculateButton = ({
  isLoading,
  children,
  size = 'md',
  variant = 'primary',
  onClick,
  disabled,
}: ITCCalculateButtonProps) => {
  const { isSubmitting, values } = useFormikContext<any>();

  const solarEdgeSelected = values.inverterManufacturer === 'SolarEdge';
  const optimizerAcknowledged = values.optimizerAck;
  const type = typeof onClick === 'function' ? 'button' : 'submit';
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const isButtonDisabled = isLoading || isSubmitting || (solarEdgeSelected && !optimizerAcknowledged) || disabled;

  return (
    <Button
      type={type}
      isLoading={isLoading || isSubmitting}
      isDisabled={isButtonDisabled}
      size={size}
      variant={variant}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
};
